import React, { useState } from "react";
import Navigation from "./Navigation";

const CATEGORY_META = {
  concert:   { title: "Concert",   subtitle: "Scène & lumières",     heroBg: "/images/concert/c1.webp" },
  sport:     { title: "Sport",     subtitle: "Émotion & mouvement",  heroBg: "/images/sport/s1.webp" },
  mariage:   { title: "Mariage",   subtitle: "Amour & célébration",  heroBg: "/images/mariage/m1.webp" },
  portrait:  { title: "Portrait",  subtitle: "L'humain au centre",   heroBg: "/images/portrait/p1.webp" },
  shooting:  { title: "Shooting",  subtitle: "Mode & lifestyle",     heroBg: "/images/shooting/s1.webp" },
  "extérieur": { title: "Extérieur", subtitle: "Lumière naturelle",  heroBg: "/images/extérieur/e1.webp" },
  exterieur: { title: "Extérieur", subtitle: "Lumière naturelle",    heroBg: "/images/extérieur/e1.webp" },
  paysage:   { title: "Paysage",   subtitle: "Nature & horizons",    heroBg: "/images/paysage/p2.webp" },
};

const IMAGES = {
  concert: [
    "c1.webp","c2.webp","c3.webp","c4.webp","c5.webp","c6.webp","c7.webp","c8.webp","c9.webp",
    "c10.webp","c11.webp","c12.webp","c13.webp","1.webp","4.webp","5.webp","6.webp","7.webp",
    "9.webp","11.webp","12.webp","c15.webp","c16.webp","c17.webp","c18.webp","c19.webp",
    "13.webp","14.webp","10.webp","8.webp","3.webp","2.webp",
  ],
  portrait: [
    "p1.webp","p2.webp","p3.webp","p4.webp","p5.webp","p6.webp","p7.webp","p8.webp",
    "p11.webp","p13.webp","p14.webp","p9.webp","p12.webp","p10.webp",
  ],
  mariage: [
    "m1.webp","m2.webp","m3.webp","m4.webp","m7.webp","m8.webp","m9.webp","m10.webp",
    "m11.webp","m12.webp","m13.webp","m14.webp","m15.webp","m17.webp","m18.webp","m19.webp",
    "m16.webp","1.webp","m5.webp","m6.webp",
  ],
  "extérieur": [
    "e1.webp","e2.webp","e3.webp","e4.webp","e5.webp","e6.webp","e7.webp","e8.webp","e9.webp",
    "e10.webp","e11.webp","e12.webp","e13.webp","e14.webp","e15.webp","e16.webp","e17.webp",
    "e18.webp","e19.webp","e20.webp","e21.webp","e22.webp","e23.webp","e24.webp","e25.webp",
  ],
  exterieur: [
    "e1.webp","e2.webp","e3.webp","e4.webp","e5.webp","e6.webp","e7.webp","e8.webp","e9.webp",
    "e10.webp","e11.webp","e12.webp","e13.webp","e14.webp","e15.webp","e16.webp","e17.webp",
    "e18.webp","e19.webp","e20.webp","e21.webp","e22.webp","e23.webp","e24.webp","e25.webp",
  ],
  paysage: [
    "p2.webp","p3.webp","p7.webp","p8.webp","p9.webp","p10.webp","p11.webp","p12.webp",
    "p13.webp","p14.webp","p15.webp","p16.webp","p6.webp","p5.webp","p4.webp",
  ],
  shooting: [
    "s1.webp","s2.webp","s3.webp","s4.webp","s5.webp","s6.webp","s7.webp","s8.webp","s9.webp",
  ],
  sport: [
    "s1.webp","s2.webp","s3.webp","s4.webp","s5.webp","s6.webp","s8.webp","s10.webp",
    "s12.webp","s14.webp","s15.webp","s18.webp","s19.webp","s20.webp","s21.webp","s22.webp",
    "s16.webp","s13.webp","s17.webp","s11.webp","s9.webp","s7.webp",
  ],
};

function ImageGallery({ category }) {
  const [lightbox, setLightbox] = useState(null);

  const meta = CATEGORY_META[category] || { title: category, subtitle: "", heroBg: "" };
  const imageList = IMAGES[category] || [];

  // Normalize category for the public path (handle accent)
  const pathCategory = category === "exterieur" ? "extérieur" : category;

  const handleKey = (e, src) => {
    if (e.key === "Enter" || e.key === " ") setLightbox(src);
  };
  const closeLightbox = (e) => {
    if (e.target === e.currentTarget || e.key === "Escape") setLightbox(null);
  };

  return (
    <div className="gallery-page">
      <Navigation />

      {/* ── HERO BANNIÈRE ────────────────────────────── */}
      <header className="gallery-hero" aria-label={`Galerie ${meta.title}`}>
        {meta.heroBg && (
          <div className="gallery-hero__bg" aria-hidden="true">
            <img src={meta.heroBg} alt="" loading="eager" decoding="async" />
          </div>
        )}
        <div className="gallery-hero__overlay" aria-hidden="true" />
        <div className="gallery-hero__content">
          <p className="gallery-hero__eyebrow">Portfolio</p>
          <h1 className="gallery-hero__title">{meta.title}</h1>
          <p className="gallery-hero__subtitle">{meta.subtitle}</p>
        </div>
      </header>

      {/* ── GRILLE PHOTOS ────────────────────────────── */}
      <main className="gallery-grid-section">
        {imageList.length === 0 ? (
          <p className="gallery-grid__empty">Aucune photo disponible.</p>
        ) : (
          <ul className="gallery-grid" aria-label={`Galerie — ${meta.title}`}>
            {imageList.map((img, i) => {
              const src = `/images/${pathCategory}/${img}`;
              return (
                <li key={img + i} className="gallery-grid__item">
                  <button
                    className="gallery-grid__btn"
                    onClick={() => setLightbox(src)}
                    onKeyDown={(e) => handleKey(e, src)}
                    aria-label={`Voir la photo ${i + 1} — ${meta.title}`}
                    type="button"
                  >
                    <img
                      src={src}
                      alt={`${meta.title} — cliché ${i + 1}`}
                      loading={i < 6 ? "eager" : "lazy"}
                      decoding="async"
                    />
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </main>

      {/* ── LIGHTBOX ─────────────────────────────────── */}
      {lightbox && (
        <div
          className="gallery-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Photo en plein écran"
          onClick={closeLightbox}
          onKeyDown={closeLightbox}
          tabIndex={-1}
        >
          <button
            className="gallery-lightbox__close"
            onClick={() => setLightbox(null)}
            aria-label="Fermer"
            type="button"
          >
            ×
          </button>
          <img
            src={lightbox}
            alt="Vue en plein écran"
            className="gallery-lightbox__img"
          />
        </div>
      )}
    </div>
  );
}

export default ImageGallery;
